module.exports = __webpack_public_path__ + "media/images/convenient-8ac0b9bd2965bd4fbc73f8dc294a2aa6.png";